import { dateToYMDformat, toTime } from 'utils/date'
import React, { useEffect, useState } from 'react'
import { warehousepermissions } from 'rest/urls'
import { Form } from '../MagAccess/NewAccess'
import { GET } from 'rest/request'

const usePreviousAccess = (
  setForm: React.Dispatch<React.SetStateAction<Form>>,
  permissionId?: string
) => {
  const [previousPermission, setPreviousPermission] = useState<warehouse.WarehouseSharing | null>(null)
  const [isLoading, setLoading] = useState(false)

  const getPreviousPermission = async (permissionId: string) => {
    if (isLoading) return
    setLoading(true)
    try {
      const response: response.DataResponse<warehouse.WarehouseSharing> = await GET(`${warehousepermissions}/${permissionId}`)
      if (response.data) {
        setLoading(false)
        setForm(prev => {
          const newForm: Form = {
            ...prev,
            name: response.data.userName,
            phone: response.data.phone,
          }
          if (response.data.validUntil) {
            const date = new Date(response.data.validUntil)
            newForm.date = dateToYMDformat(date)
            newForm.time = toTime(date)
          }
          if (response.data.disabled) {
            newForm.disabled = response.data.disabled
          }
          if (response.data.functions) {
            newForm.functions = response.data.functions
          }
          return newForm
        })
        setPreviousPermission(response.data)

      } else {
        throw new Error('Wrong response')
      }
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!permissionId) return
    getPreviousPermission(permissionId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionId])

  return {
    isLoading,
    previousPermission
  }
}

export default usePreviousAccess